export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_CREATED_PRODUCT = "SET_CREATED_PRODUCT";
export const SET_UPDATED_PRODUCT = "SET_UPDATED_PRODUCT";
export const REMOVE_DELETED_PRODUCT = "REMOVE_DELETED_PRODUCT";
export const SET_PRODUCT_ERROR = "SET_PRODUCT_ERROR";
export const SET_PRODUCTS_LOADING = "SET_PRODUCTS_LOADING";
export const SET_PRODUCTS_FETCHING = "SET_PRODUCTS_FETCHING";
